import axios from "axios"

const axiosInc = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { accept: 'application/json' }
})
export default axiosInc